/**
 * render-aggregate-viewing-time-by-bvod-player
 *
 * @author    Augusto Silvino <augusto.silvino@mediatel.co.uk>
 * @copyright 2018 Mediatel Limited.
 */

"use strict";

import numberFormat from "../common/number-format";

export default (data, datatype, filter) => {
    if(! data.length) {
        return 'No data for this period';
    }

    const decimals = (parseInt(datatype) === 0) ? 0 : 2;
    const stationHtml = [];
    let showTvDevice = false;
    const rows = data.filter(
        s => filter ? s.player_name.match(new RegExp("^" + filter + "|All BVOD services", "i")) : true
    ).map(
        (row, i) => {
            let odTooltip = '';
            if (row.label.hasOwnProperty('info')) {
                let label = `<strong>${row.label.info}</strong>`;
                if (row.label.hasOwnProperty('tv')) {
                    label += `<br /><strong>TV:</strong> ${row.label.tv}`;
                }
                if (row.label.hasOwnProperty('nontv')) {
                    label += `<br /><strong>Non TV:</strong> ${row.label.nontv}`;
                }
                odTooltip = `data-popover="${label}"`;
            }

            let table = `<tr id="player_${row.player_id}${row.player_id === "0" ? Math.floor(Math.random() * 10) : ""}" class="info_popover ${i % 2 === 0 ? "even" : "odd"}${row.player_id === "0" ? " summary no-sort" : ""}" ${odTooltip}>` +
                `<td>${row.player_name}</td>` +
                `<td>${row.stream_name}</td>` +
                `<td class="number align_center">${(row.all_devices) ? numberFormat(row.all_devices, decimals) : "-"}</td>` +
                `<td class="number align_center">${(row.pc) ? numberFormat(row.pc, decimals) : "-"}</td>` +
                `<td class="minutage align_center">${(row.tablet) ? numberFormat(row.tablet, decimals) : "-"}</td>` +
                `<td class="number align_center">${(row.smartphone) ? numberFormat(row.smartphone, decimals) : "-"}</td>`;
            if (row.hasOwnProperty('tv_device')) {
                showTvDevice = true;
                table += `<td class="number align_center">${(row.tv_device) ? numberFormat(row.tv_device, decimals) : "-"}</td>`;
            }
            table += `<td class="number align_center">${(row.other) ? numberFormat(row.other, decimals) : "-"}</td>` +
                "</tr>";
            return table;
        }
    ).join("\n");
    let table = `<table class="datagrid sortable">` +
        `<thead><tr class="no-sort">` +
        `<th class="no_bkgd group" colspan="2" style="background: #FFF; border: 0px;"></th>` +
        `<th class="no_bkgd group center" colspan="6">Total viewing time (minutes)</th>` +
        `</tr><tr class="no-sort">` +
        `<th data-sort-method="text" class="no_bkgd center">BVOD service</th>` +
        `<th data-sort-method="text" class="no_bkgd center">Stream</th>` +
        `<th data-sort-method="number" class="no_bkgd minutage center">All devices</th>` +
        `<th data-sort-method="number" class="no_bkgd minutage center">PC/laptop</th>` +
        `<th data-sort-method="number" class="no_bkgd minutage center">Tablet</th>` +
        `<th data-sort-method="number" class="no_bkgd minutage center">Smartphone</th>`;
    if (showTvDevice) {
        table += `<th data-sort-method="number" class="no_bkgd minutage center">TV device</th>`;
    }
    table += `<th data-sort-method="number" class="no_bkgd minutage center">Other</th>` +
        `</tr></thead>${rows}<tbody></tbody></table>`;
    stationHtml.push(table);
    return stationHtml.join("\n");
}
